<div class="w-full flex justify-center desktop-banner mt-4 p-4">
    <prcins-notification class="sm:w-3/4 max-w-2xl"
        [notification]="notification"></prcins-notification></div>
<prcins-desktop-banner></prcins-desktop-banner>
<prcins-mobile-banner class="w-full"></prcins-mobile-banner>